import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import appConfig from 'config/app.config';
import { schoolUiTexts } from 'data/ui-texts';
import {scenariosData} from 'data/scenarios-data';
import Button from 'components/ui/button/button';
import Logo from 'components/ui/logo/logo';
import Countdown from 'components/ui/countdown/countdown';
import Leaderboard from 'components/ui/leaderboard/leaderboard';
import PopupGameStatusWarning from 'components/ui/popup-game-status-warning/popup-game-status-warning';
import GameCode from 'components/ui/game-code/game-code';
import './game-open.scss';
import { soundsData } from 'data/sound-data';

const GameOpen = (props) => {
	/* Props */
	const {
		schoolData, 
		gameGroups, 
		updateGame, 
		handleGoToPage, 
		updateBackground, 
		game, 
		handlePlayMusic, 
		updateGroup
	} = props;


	/* Track if show/hide leaderboard */
	const [showLeaderboard, setShowLeaderboard] = useState(true);
 
	/* Track if show/hide warning popup */
	const [showStartGameWarningPopup, setShowStartGameWarningPopup] = useState(false);

	const scenarioData = game.scenarioId ? scenariosData[game.scenarioId] : scenariosData['game1'];
	const gameDurationMinutes = scenarioData.gameDurationMinutes;

	/**
	 * Component did mount / will unmount
	 */
	useEffect(() => {
		/* Check if time has run out */
		const currentTime = new Date();
		let endTime = 0;
		if (game.startTime) {
			endTime = new Date(game.startTime + gameDurationMinutes * 60000);
		} else {
			endTime = new Date(new Date().getTime() + gameDurationMinutes * 60000);
		}
		const timeLeft = endTime - currentTime;
		if (timeLeft < (appConfig.autoCloseLeaderBoardWithXMinutesLeft * 60000)) {
			/* Don't initially show leaderboard if time has run out or less than x minutes left */
			setShowLeaderboard(false);
		}
	

		// Set background image id
		updateBackground('school', game.scenarioId);

		const audioName = game.scenarioId + 'Music';
		handlePlayMusic(false, soundsData[audioName]);

		
		return () => {
			handlePlayMusic(false, null);
		};
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className={'GameOpen ' + game.scenarioId}>
			{/* Logo */}
			<div className="GameOpen-logo" onClick={() => {handleGoToPage('landing');}} >
				<Logo scenarioId={game.scenarioId} />
			</div>

			{/* School name */}
			{<div className="GameOpen-schoolName">
				<span>{schoolData.name}</span>
			</div>}

			{/* Game code */}
			<GameCode page={'game-open' + (showLeaderboard ? ' top' : '')} game={game}/>

			{/* Countdown timer */}
			<Countdown 
				startTime={game.startTime}
				layout={showLeaderboard ? 'small' : 'default'}
				minutes={gameDurationMinutes}
				setShowLeaderboard={setShowLeaderboard}
			/>

			{/* Leaderboard  */}
			<div className={'GameOpen-leaderBoard' + (showLeaderboard ? '' : ' hidden')}>
				<Leaderboard 
					status="open" 
					gameGroups={gameGroups} 
					setShowLeaderboard={setShowLeaderboard} 
					scenarioId={game.scenarioId} 
					updateGroup={updateGroup}
				/>
			</div>
			

			<div className="GameOpen-buttons">
				{/* Back to landing page btn */}
				<div className="GameOpen-backBtn">
					<Button 
						classes={['blueLight', game.scenarioId, 'backBtn', 'responsive']}
						text={schoolUiTexts.back}
						onClick={() => {handleGoToPage('landing');}}
					/>
				</div>

				{/* Toggle highscore btn */}
				<div className="GameOpen-highscoreBtn">
					<Button 
						classes={[
							'blueLight', 
							game.scenarioId, 
							'highscoreBtn', 
							'responsive ' + (showLeaderboard ? 'countdown' : 'trophy')
						]}
						text={(showLeaderboard ? schoolUiTexts.countdownTimer : schoolUiTexts.leaderboard)}
						onClick={() => {setShowLeaderboard(!showLeaderboard);}}
					/>
				</div>

				{/* Close game btn */}
				<div className="GameOpen-closeBtn">
					<Button 
						classes={['blueLight', game.scenarioId, 'responsive']}
						text={schoolUiTexts.closeGameBtn}
						onClick={() => {setShowStartGameWarningPopup(true);}}
					/>
				</div>
			</div>
			
			{/* Warning popup (confirm close game) */}
			{showStartGameWarningPopup &&
				<PopupGameStatusWarning 
					scenarioId={game.scenarioId}	
					newStatus='done'
					updateGame={updateGame}
					closePopup={() => {setShowStartGameWarningPopup(false);}}
				/>}
		</div>
	);
};

GameOpen.propTypes = {
	schoolData: PropTypes.object.isRequired,
	game: PropTypes.object.isRequired,
	gameGroups: PropTypes.array.isRequired,
	updateGame: PropTypes.func.isRequired,
	handleGoToPage: PropTypes.func.isRequired,
	updateBackground: PropTypes.func.isRequired,
	handlePlayMusic: PropTypes.func.isRequired,
	updateGroup: PropTypes.func.isRequired
};

export default GameOpen;
